import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../actions/utilAction';

export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const GET_DATAANALYTICS_API = `${API_URL}/patient-encounter/GetPatientBehaviorsReductionDetails`;

export const dataAnalyticsActionTypes = {
    get_DataAnalytics: createRequestActionTypes('GET_DATAANALYTICS'),
};

export const MODULE = 'DCMASTER_DATAANALYTICS';


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataAnalyticsBehaviors/constants/ApiConstants.js